import axios from 'api/axios'
import { AdminUser } from 'types'
import handleAxiosError from 'utils/handleAxiosError'
import localStorage from 'utils/localStorage'

/**
 * Type Interface for the body of the login request
 */
export interface LoginBody {
	email: string
	password: string
	rememberMe: Boolean
	source: 'WEB_APP'
}
/**
 * Type Interface for the Response object you get from the login request if successful
 */
export interface LoginResponse {
	user: AdminUser
}

export const login = async (body: LoginBody) => {
	try {
		const { data } = await axios.post<LoginResponse>('management/login', body)
		localStorage.set('token', data.user.token)
		localStorage.set('refreshToken', data.user.refreshToken)
		localStorage.set('user', data.user)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default login
